
import React from 'react';
import { Avatar, FormControl, FormHelperText } from '@material-ui/core';

import { ClientContext } from '../../ClientContext';
import { ClientErrorContext } from '../../ClientErrorContext';
import { theme } from '../../../../theme';

export function ClientAvatarShow() {
    const clientContext = React.useContext(ClientContext);
    const clientErrorContext = React.useContext(ClientErrorContext);
    
    const [image, setImage] = React.useState<string>('');

    React.useEffect(() => {
        if (clientContext.clientAvatarFile != null) {
            const img = URL.createObjectURL(clientContext.clientAvatarFile);

            if (image) 
                URL.revokeObjectURL(image);

            setImage(img);
        } else {
            URL.revokeObjectURL(image);
            setImage('');
        }
    }, [clientContext.clientAvatarFile]);

    const getClientImage = () => {
        if (image != ''){
            return image;
        }
        else if (clientContext.client.imageUrl != '') {
            return clientContext.client.imageUrl;
        }
        else {
            return '';
        }
    };

    return (
        <FormControl component="image">
            <Avatar 
                src={getClientImage()} 
                variant="square"
                style={{
                    margin: '10px',
                    width: '200px',
                    height: '200px',
                    border:  clientErrorContext.avatarFileError && !clientContext.clientAvatarFile
                        ? `1px solid ${theme.palette.error.main}`
                        : 0,
                }}
            />
            {clientErrorContext.avatarFileError && !clientContext.clientAvatarFile && (
                <FormHelperText error style={{ paddingLeft: '10px' }}>
                    Campo obrigatório
                </FormHelperText>
            )}
        </FormControl>
    );
}